import React, { useEffect, useMemo, useState } from "react";

import btnImg from "../../../assets/images/svg/Search.svg";
import totalPOIMg from "../../../assets/images/svg/Total PO Value.svg";
import firstTimeCostSavingsImg from "../../../assets/images/svg/First time cost savings.svg";
import graphImg from "../../../assets/images/svg/Graph.svg";
import trophyImg from "../../../assets/images/svg/Trophy.svg";
import vendorImg from "../../../assets/images/svg/Vendors.svg";
import prImg from "../../../assets/images/svg/File Edit.svg";
import invoiceImg from "../../../assets/images/svg/tax-fill.svg";

import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import classes from "../../TabStyles/DashboardTab.module.css";
import DSelectInput from "../../../components/Dashboard/DashboardInputs/DSelectInput";
import DButton from "../../../components/Dashboard/DashboardButtons/Dbutton";
import DDateInput from "../../../components/Dashboard/DashboardInputs/DDateInput";
import DataTable from "../../../components/common/DataTable/DataTableSorting";
import PaginationComponent from "../../../components/common/Pagination/PaginationComponent";
import { nextPageClick, previouPageClick } from "../../../utils/pagination";
import SearchBar from "../../../components/common/SearchBar/SearchBar";
import { useSelector } from "react-redux/es/hooks/useSelector";
import Reportcard from "../../../components/Dashboard/ReportCards/ReportCard";
import DonutChart from "../../../components/Dashboard/Charts/DonutChart/DonutChart";
import LineChart from "../../../components/Dashboard/Charts/LineChart/LineChart";
import BarChart from "../../../components/Dashboard/Charts/BarChart/BarChart";
import HorizontalBarChart from "../../../components/Dashboard/Charts/BarChart/HorizontalBarChart";
import { API_ENDPOINT } from "../../../services/api/resources";
import axios from "axios";
import { emptyCheck } from "../../../utils/validations";
import { weeklyReportObjFormate } from "../../../utils/chartKeyFormat";
import { DASHBOARD_CHART_PALETTES } from "../../../utils/chartColors";
import NewBuyerDashboard from "./NewBuyerDashboardV2";
import UserDashboard from "./UserDashboard";
import { useNavigate } from "react-router-dom";
import {
  useMerchantInvoiceDashboardOffline,
  useOfflineGRNs,
  useOfflinePRs,
  useOfflineTWM,
  useOfflineRFQs,
} from "../../../offline";

const normalizeMetricValue = (value) => {
  if (typeof value === "number") return value;
  const numeric = Number(String(value ?? "").replace(/,/g, "").replace(/[^\d.-]/g, ""));
  return Number.isFinite(numeric) ? numeric : 0;
};

const getDashboardSection = (source, ...path) => {
  return path.reduce((current, key) => current?.[key], source) || {};
};

const mapObjectToChart = (source = {}, limit = Infinity) => {
  const entries = Object.entries(source || {});
  const sliced = Number.isFinite(limit) ? entries.slice(0, limit) : entries;
  return {
    labels: sliced.map(([label]) => label),
    values: sliced.map(([, value]) => normalizeMetricValue(value)),
  };
};

const mapArrayToChart = (items = [], labelKey = "name", valueKey = "amount", limit = Infinity) => {
  const safeItems = Array.isArray(items) ? items.slice(0, limit) : [];
  return {
    labels: safeItems.map((item) => String(item?.[labelKey] ?? "").trim()).filter(Boolean),
    values: safeItems.map((item) => normalizeMetricValue(item?.[valueKey])),
  };
};

const formatPercent = (value) => {
  const numeric = Number(value);
  if (Number.isFinite(numeric)) {
    const formatted = numeric.toFixed(2).replace(/\.00$/, "");
    return `${formatted}%`;
  }
  return `${value ?? 0}%`;
};


/** Dark green pill */
const SectionPill = ({ title }) => (
  <div style={{
    display: "inline-flex", alignItems: "center",
    background: "#1a4d3a", color: "#fff",
    borderRadius: "20px", padding: "4px 16px",
    fontSize: "14px", fontWeight: 700,
    fontFamily: '"gilroyBold", Inter, sans-serif',
    whiteSpace: "nowrap",
  }}>
    {title}
  </div>
);

/** White section card â€” vertical layout inside */
const SectionCard = ({ title, dropdowns, children }) => (
  <div
    style={{
      background: "#fff",
      borderRadius: "16px",
      border: "1px solid #f0f0f0",
      boxShadow: "0 2px 14px rgba(15,23,42,0.06)",
      padding: "1.1rem 1.25rem",
      boxSizing: "border-box",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      height: "100%",              // â­ IMPORTANT
      minHeight: "100%",           // â­ keeps equal height
      marginBottom: "1.25rem",
    }}
  >
    {/* Header: pill + dropdowns */}
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "0.85rem", flexWrap: "wrap", gap: "0.5rem" }}>
      <SectionPill title={title} />
      {dropdowns && (
        <div onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
          {dropdowns}
        </div>
      )}
    </div>
    {children}
  </div>
);

/** Thin divider */
const Divider = () => (
  <div style={{ borderTop: "1px solid #f3f4f6", margin: "0.9rem 0" }} />
);

const MetricCard = ({ title, value, note, accent = "#0f766e", onClick }) => (
  <div
    onClick={onClick}
    style={{
      background: "#fff",
      border: "1px solid #e5e7eb",
      borderRadius: "16px",
      padding: "1rem",
      minHeight: "108px",
      boxShadow: "0 2px 10px rgba(15,23,42,0.05)",
      cursor: onClick ? "pointer" : "default",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      gap: "0.5rem",
      position: "relative",
      overflow: "hidden",
    }}
  >
    <div style={{ position: "absolute", inset: "0 auto auto 0", width: "100%", height: "4px", background: accent, opacity: 0.95 }} />
    <div style={{ paddingTop: "0.35rem" }}>
      <div style={{ fontSize: "14px", fontFamily: '"gilroyMedium", Inter, sans-serif', color: "#374151", lineHeight: 1.35 }}>
        {title}
      </div>
      <div style={{ fontSize: "22px", fontFamily: '"gilroyBold", Inter, sans-serif', color: "#111827", lineHeight: 1.15, marginTop: "0.35rem" }}>
        {value}
      </div>
    </div>
    {note ? (
      <div style={{ fontSize: "12px", fontFamily: '"gilroyMedium", Inter, sans-serif', color: "#6b7280" }}>
        {note}
      </div>
    ) : null}
  </div>
);

/** Sub-section heading inside a card */
const InlineHeading = ({ title }) => (
  <div style={{ fontSize: "14px", fontFamily: '"gilroyMedium", Inter, sans-serif', color: "#111827", marginBottom: "0.75rem" }}>
    {title}
  </div>
);

/** Year + Month dropdowns */
const Dropdowns = ({ year, month, yearOptions, monthOptions, onYearChange, onMonthChange }) => (
  <div style={{ display: "flex", gap: 8 }}>
    <select value={year} onChange={(e) => onYearChange(Number(e.target.value))} style={dropStyle}>
      {yearOptions.map((y) => <option key={y} value={y}>{y}</option>)}
    </select>
    <select value={month} onChange={(e) => onMonthChange(e.target.value === "all" ? "all" : Number(e.target.value))} style={dropStyle}>
      {monthOptions.map((m) => <option key={m.value} value={m.value}>{m.label}</option>)}
    </select>
  </div>
);

const dropStyle = {
  fontSize: "12px", padding: "4px 10px", borderRadius: "8px",
  border: "1px solid #e5e7eb", background: "#f9fafb",
  color: "#374151", cursor: "pointer", outline: "none",
};

const twoColGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
  gap: "0.9rem",
  alignItems: "stretch",
};

const stackCol = {
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  minWidth: 0,
};

const blockWrap = { minWidth: 0 };
const nestedCard = {
  background: "#f8fafc",
  border: "1px solid #e5e7eb",
  borderRadius: "14px",
  padding: "0.9rem",
  minWidth: 0,
};

const skeletonBase = {
  background: "linear-gradient(90deg, #e5e7eb 0%, #f3f4f6 50%, #e5e7eb 100%)",
  backgroundSize: "200% 100%",
  borderRadius: "12px",
};

const SkeletonBlock = ({ width = "100%", height = 16, radius, style = {} }) => (
  <div
    aria-hidden="true"
    style={{
      ...skeletonBase,
      width,
      height,
      borderRadius: radius || skeletonBase.borderRadius,
      ...style,
    }}
  />
);

const BuyerDashboardSkeleton = () => (
  <div className={classes.dashboardPage}>
    <div className={classes.pageSectionPad}>
      <SkeletonBlock width="220px" height={34} radius="999px" />
    </div>

    <div className={classes.pageSectionPadTop}>
      <div className={`${classes.filters} ${classes.flex}`} style={{ gap: "0.85rem", flexWrap: "wrap" }}>
        <SkeletonBlock width="190px" height={42} />
        <SkeletonBlock width="190px" height={42} />
        <SkeletonBlock width="180px" height={42} />
        <SkeletonBlock width="180px" height={42} />
        <SkeletonBlock width="140px" height={42} radius="999px" />
      </div>
    </div>

    <div className={classes.pageSectionPadMain}>
      <div className={classes.dashboardGroup}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: "1.25rem",
            marginBottom: "1.75rem",
            alignItems: "stretch",
          }}
        >
          {Array.from({ length: 7 }).map((_, index) => (
            <div
              key={`metric-skeleton-${index}`}
              style={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: "16px",
                padding: "1rem",
                minHeight: "108px",
                boxShadow: "0 2px 10px rgba(15,23,42,0.05)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                gap: "0.85rem",
              }}
            >
              <SkeletonBlock width="58%" height={14} />
              <SkeletonBlock width="42%" height={28} />
              <SkeletonBlock width="36%" height={12} />
            </div>
          ))}
        </div>

        <div style={{ display: "grid", gap: "1.25rem" }}>
          {Array.from({ length: 4 }).map((_, index) => (
            <div
              key={`section-skeleton-${index}`}
              style={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: "16px",
                padding: "1.1rem 1.25rem",
                boxShadow: "0 2px 14px rgba(15,23,42,0.06)",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", gap: "0.75rem", marginBottom: "1rem", flexWrap: "wrap" }}>
                <SkeletonBlock width="240px" height={28} radius="999px" />
                <SkeletonBlock width="120px" height={28} radius="999px" />
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: "1rem" }}>
                <div style={{ ...nestedCard, minHeight: 220 }}>
                  <SkeletonBlock width="45%" height={16} style={{ marginBottom: "0.9rem" }} />
                  <SkeletonBlock width="100%" height={170} />
                </div>
                <div style={{ ...nestedCard, minHeight: 220 }}>
                  <SkeletonBlock width="52%" height={16} style={{ marginBottom: "0.9rem" }} />
                  <SkeletonBlock width="100%" height={170} />
                </div>
              </div>

              <div style={{ marginTop: "1rem" }}>
                <SkeletonBlock width="30%" height={16} style={{ marginBottom: "0.85rem" }} />
                <SkeletonBlock width="100%" height={220} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
   MAIN COMPONENT
â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */
const BuyerDashboardTab = () => {
  const data = useSelector((state) => state.loginData.value);
  const navigate = useNavigate();

  const [auth_token, setAuthToken] = useState(data?.auth_token);
  const [buyer_token, setBuyerToken] = useState(data?.user?.token);
  const [org_token, setOrgToken] = useState(data?.user?.token);
  const [loadingState, setLoadingState] = useState(false);
  const DASHBOARD_REQUEST_TIMEOUT = 60000;

  const [searchQuery, setSearchQuery] = useState("");
  const [sortingColumnName, setSortingColumnName] = useState(null);
  const [sortingOrder, setSortingOrder] = useState(null);
  const order = sortingOrder === null || sortingOrder === "asc" ? "desc" : "asc";

  const [paginationData, setPaginationData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = paginationData?.current_page_count;
  const totalItems = paginationData?.page_count;

  const [tableProps] = useState({ isLoading: false, errorMessage: "" });
  const [pageNumber, setPageNumber] = useState(1);
  const [spendItems, setSpendItems] = useState([]);
  const [spendItemsLoading, setSpendItemsLoading] = useState(false);
  const [vendorTotalCount, setVendorTotalCount] = useState(0);

  const [vendorList, setVendorsList] = useState({ values: { tokens: [], visibleOption: [] } });
  const [vendorDetails, setVendorDetails] = useState({ vendorName: "", vendorID: "" });
  const [itemList, setItemList] = useState({ values: { tokens: [], visibleOption: [] } });
  const [vendorNameDetails, setVendorNameDetails] = useState({ buyerName: "", buyerID: "" });
  const [vendornameList, setVendornameList] = useState({ values: { tokens: [], visibleOption: [] } });
  const [itemCode, setItemCode] = useState({ item_code: "", item_token: "" });
  const [duration, setDuration] = useState();
  const [fromDate, setFromDate] = useState({ value: "", isValid: true });
  const [toDate, setToDate] = useState({ value: "", isValid: true });

  const [prSummaryOverride, setPrSummaryOverride] = useState(null);
  const [raisedPRSummary, setRaisedPRSummary] = useState(null);
  const [approvalPRSummary, setApprovalPRSummary] = useState(null);
  const [dashboardResponse, setDashboardResponse] = useState({});
  const [hasLoadedDashboard, setHasLoadedDashboard] = useState(false);

  const [analyticsData, setAnalyticsData] = useState({
    totalPOValue: "", costSavingsMetric1: "", costSavingsMetric2: "", repeatPurchaseCostSavings: "",
    pendingVsCloseRFQ: [], openCancelPending: [], poTotal: "", submittedVsSelectedRFQ: [],
    totalRFQCreatedValueMonthWise: [], totalRFQCreatedLabelMonthWise: [],
    totalRFQCreatedValueWeekWise: [], totalRFQCreatedLabelWeekWise: [],
    totalPurchaseOrdersValueMonthWise: [], totalPurchaseOrdersLabelMonthWise: [],
    totalPurchaseOrdersValueWeekWise: [], totalPurchaseOrdersLabelWeekWise: [],
    totalSpentByItems: { labels: [], values: [] },
    vendorResponseTime: { labels: [], values: { minTime: [], maxTime: [] } },
    approverResponseTime: { labels: [], values: { minTime: [], maxTime: [] } },
    poStatusSummary: { approved: 0, rejected: 0, pending: 0, cancelled: 0 },
    purchaseOrderStatus: [], topSelectedVendorsByRFQ: [],
  });

  const [RFQCreationOption, setRFQCreationOption] = useState("monthly");
  const [totalPOOption, setTotalPOOption] = useState("monthly");
  const [prChartYear, setPRChartYear] = useState(new Date().getFullYear());
  const [prChartMonth, setPRChartMonth] = useState("all");
  const [prMonthlyData, setPRMonthlyData] = useState({ labels: [], values: [] });
  const [rfqChartYear, setRfqChartYear] = useState(new Date().getFullYear());
  const [rfqChartMonth, setRfqChartMonth] = useState("all");
  const [poChartYear, setPoChartYear] = useState(new Date().getFullYear());
  const [poChartMonth, setPoChartMonth] = useState("all");
  const [orgCreatedYear, setOrgCreatedYear] = useState(new Date().getFullYear());
  const [activeSection, setActiveSection] = useState("controlTower");

  const org_id = data?.org_id || data?.user?.org_id || data?.organization_id || data?.user?.organization_id || "";

  const { data: merchantInvoiceSummary } = useMerchantInvoiceDashboardOffline(auth_token, buyer_token, org_id);
  const { grns = [] } = useOfflineGRNs(auth_token, buyer_token);
  const { twmList = [] } = useOfflineTWM(auth_token, buyer_token);
  const { rfqs = [] } = useOfflineRFQs(auth_token, buyer_token, null, "", "", "", "", "", false);
  const { prs = [], refetch: refetchPRs } = useOfflinePRs(auth_token, buyer_token, org_id, data?.access_type);

  /* â”€â”€ All existing effects (UNCHANGED) â”€â”€ */
  useEffect(() => {
    if (!prs || prs.length === 0) return;
    const dates = prs.map((pr) => { const d = new Date(pr?.created_on || pr?.request_date || pr?.date || ""); return isNaN(d.getTime()) ? null : d.getFullYear(); }).filter(Boolean);
    if (dates.length > 0) setOrgCreatedYear(Math.min(...dates));
  }, [prs]);

  useEffect(() => {
    if (!prs || prs.length === 0) return;
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const filtered = prs.filter((pr) => {
      const date = new Date(pr?.created_on || pr?.request_date || pr?.date || "");
      if (isNaN(date.getTime())) return false;
      const yearMatch = date.getFullYear() === Number(prChartYear);
      return prChartMonth === "all" ? yearMatch : yearMatch && date.getMonth() === Number(prChartMonth);
    });
    if (prChartMonth === "all") {
      const mc = Array(12).fill(0);
      filtered.forEach((pr) => { const d = new Date(pr?.created_on || pr?.request_date || pr?.date || ""); if (!isNaN(d.getTime())) mc[d.getMonth()] += 1; });
      setPRMonthlyData({ labels: monthNames, values: mc });
    } else {
      const dim = new Date(Number(prChartYear), Number(prChartMonth) + 1, 0).getDate();
      const dc = Array(dim).fill(0);
      filtered.forEach((pr) => { const d = new Date(pr?.created_on || pr?.request_date || pr?.date || ""); if (!isNaN(d.getTime())) dc[d.getDate() - 1] += 1; });
      setPRMonthlyData({ labels: Array.from({ length: dim }, (_, i) => String(i + 1)), values: dc });
    }
  }, [prs, prChartYear, prChartMonth]);

  useEffect(() => { setAuthToken(data?.auth_token); setBuyerToken(data?.user?.token); setOrgToken(data?.user?.token); }, [data?.auth_token, data?.user?.token]);
  useEffect(() => { if (auth_token && buyer_token && (String(data?.access_type || "").toLowerCase() === "user" || org_id)) refetchPRs?.(); }, [auth_token, buyer_token, org_id, data?.access_type, refetchPRs]);

  useEffect(() => {
    if (!prs || prs.length === 0) return;
    const normStatus = (s, approvers) => { let n = String(s || "").trim().toLowerCase(); if (n) return n; const al = Array.isArray(approvers) ? approvers : []; const anyRej = al.some((a) => ["rejected", "cancelled", "canceled"].includes(String(a?.status || "").toLowerCase())); const allApp = al.length > 0 && al.every((a) => String(a?.status || "").toLowerCase() === "approved"); return anyRej ? "rejected" : allApp ? "approved" : "pending"; };
    const sumOverall = (list) => { let a = 0, r = 0, p = 0; list.forEach((pr) => { const s = normStatus(pr?.pr_approval_status, pr?.approvers); if (s === "approved") a++; else if (["rejected", "cancelled", "canceled"].includes(s)) r++; else p++; }); return { total: list.length, approved: a, rejected: r, pending: p }; };
    const sumRaised = (list, tok) => { if (!tok) return { total: 0, approved: 0, rejected: 0, pending: 0 }; return sumOverall(list.filter((pr) => String(pr?.buyer_token || pr?.user_token || pr?.created_by || "") === String(tok))); };
    const sumApprover = (list, uid, tok, email) => { if (!uid && !tok && !email) return { total: 0, approved: 0, rejected: 0, pending: 0 }; let a = 0, r = 0, p = 0; list.forEach((pr) => { const al = Array.isArray(pr?.approvers) ? pr.approvers : []; const me = al.find((a) => (uid && Number(a?.id) === Number(uid)) || (tok && String(a?.user_token || a?.token || a?.buyer_token || "") === String(tok)) || (email && String(a?.email || "").toLowerCase() === String(email).toLowerCase())); if (!me) return; const ms = String(me?.status || "").trim().toLowerCase(); if (ms === "approved") a++; else if (["rejected", "cancelled", "canceled"].includes(ms)) r++; else p++; }); return { total: a + r + p, approved: a, rejected: r, pending: p }; };
    setPrSummaryOverride(sumOverall(prs));
    setRaisedPRSummary(sumRaised(prs, buyer_token));
    setApprovalPRSummary(sumApprover(prs, data?.user?.id, buyer_token, data?.user?.email));
  }, [prs, buyer_token, data?.user?.id, data?.user?.email]);

  const allowedMenuIds = useMemo(() => { if (!data?.allowed_menu) return []; if (Array.isArray(data.allowed_menu)) return data.allowed_menu; if (typeof data.allowed_menu === "string") { try { return JSON.parse(data.allowed_menu); } catch { return []; } } return []; }, [data?.allowed_menu]);
  const allowedMenuSet = useMemo(() => new Set(allowedMenuIds || []), [allowedMenuIds]);
  const hasAllowedMenuFilter = Array.isArray(allowedMenuIds) && allowedMenuIds.length > 0;
  const hasMenuAccess = (id) => !hasAllowedMenuFilter || allowedMenuSet.has(id);

  const userDesignation = String(data?.user?.designation || "").trim().toLowerCase();
  const isStoreAssistant = userDesignation === "store assistant";
  const isStoreExecutive = userDesignation === "store executive";

  const buyerSections = [
    {
      id: "controlTower",
      label: "Procurement Operations Control Tower",
      description: "PR, RFQ, PO and vendor movement at a glance.",
    },
    {
      id: "spend",
      label: "Spend Intelligence",
      description: "Top spend, PO value and item-wise movement.",
    },
    {
      id: "operations",
      label: "Operations & Reconciliation",
      description: "GRN, matching and invoice monitoring.",
    },
    {
      id: "response",
      label: "Response Time",
      description: "Supplier and approver turnaround trends.",
    },
  ];

  const tabButtonStyle = (isActive) => ({
    border: "none",
    outline: "none",
    cursor: "pointer",
    borderRadius: "999px",
    padding: "0.8rem 1.05rem",
    minHeight: "48px",
    fontFamily: '"gilroyMedium", "Gilroy", Inter, sans-serif',
    fontSize: "14px",
    lineHeight: "1.1",
    letterSpacing: "0.01em",
    color: isActive ? "#0f172a" : "#475569",
    background: isActive
      ? "linear-gradient(135deg, rgba(255,255,255,0.98), rgba(241,245,249,0.95))"
      : "rgba(255,255,255,0.72)",
    boxShadow: isActive
      ? "0 10px 26px rgba(15, 23, 42, 0.12)"
      : "0 6px 18px rgba(15, 23, 42, 0.06)",
    border: isActive ? "1px solid rgba(15, 23, 42, 0.08)" : "1px solid rgba(148, 163, 184, 0.22)",
    transition: "all 0.2s ease",
    whiteSpace: "nowrap",
  });
  const isStoreManager = userDesignation === "store manager";
  const isFinanceUser = userDesignation.includes("finance");
  const hasMerchantInvoiceRole = ["invoice analyst", "finance analyst"].includes(userDesignation);

  const MENU_IDS = { PR: 2, PO: 5, GRN: 10, MERCHANT_INVOICE: 16, TWM: 17 };
  const hasPRAccess = hasMenuAccess(MENU_IDS.PR);
  const hasPOAccess = hasMenuAccess(MENU_IDS.PO);
  const hasGRNAccess = hasMenuAccess(MENU_IDS.GRN) && (isStoreAssistant || isStoreExecutive || isStoreManager);
  const hasMerchantInvoiceAccess = hasMenuAccess(MENU_IDS.MERCHANT_INVOICE) && hasMerchantInvoiceRole;

  const headings = [
    { label: "Supplier Name", field: "supplier_name" }, { label: "Geography", field: "geography" },
    { label: "Purchase Type", field: "purchase_type" }, { label: "Purchase Category", field: "category" },
    { label: "SKU or Manufacturer Part Number", field: "part_number" }, { label: "Item Code", field: "item_code" },
    { label: "Item Name", field: "item_name" }, { label: "Item Description", field: "description" },
    { label: "Unit Price", field: "unit_price" }, { label: "Total Price", field: "total_price" },
    { label: "PO Date", field: "purchase_order_date" }, { label: "Supplier Invoice date", field: "supplier_invoice_date" },
  ];
  const isBuyerDashboard = data.access_type === "Buyer";
  const isUserDashboard = data.access_type === "User";

  /* â”€â”€ API logic (UNCHANGED) â”€â”€ */
  const extractTopSelectedVendorsFromApi = (rd) => { if (!rd || typeof rd !== "object") return []; const keys = ["vendor most selected rfq", "vendors selected for most rfqs", "vendor rfq selection summary", "top selected vendors by rfq", "top vendors by rfq", "most selected vendors", "vendor_selection_frequency", "vendor selection frequency"]; for (const k of keys) { const v = rd?.[k]; if (v !== undefined && v !== null) return v; } const fk = Object.keys(rd).find((k) => { const kl = String(k).toLowerCase(); return kl.includes("vendor") && kl.includes("rfq") && (kl.includes("selected") || kl.includes("most") || kl.includes("frequency")); }); return fk ? rd[fk] : []; };

  const getAnalyticsValues = async () => {
    if (isUserDashboard) {
      const userToken =
        data?.user_token ||
        data?.user?.user_token ||
        data?.user?.token ||
        data?.organization_token ||
        buyer_token;
      const payload = { user_token: userToken };

      if (duration) payload.month_period = duration;
      if (!duration && fromDate.value) payload.from_date = fromDate.value;
      if (!duration && toDate.value) payload.to_date = toDate.value;

      setLoadingState(true);
      try {
        const response = await axios.post(API_ENDPOINT.user_dashboard, payload, {
          headers: { Authorization: `Bearer ${auth_token}` },
          timeout: DASHBOARD_REQUEST_TIMEOUT,
        });
        setDashboardResponse(response?.data?.response || response?.data || {});
      } catch (error) {
        console.error("User dashboard failed to load:", error);
        setDashboardResponse({});
      } finally {
        setLoadingState(false);
        setHasLoadedDashboard(true);
      }
      return;
    }

    const fd = new FormData(); let filters = {};
    if (vendorNameDetails.buyerID?.length) { fd.append("vendor_token", vendorNameDetails.buyerID); filters.vendor_token = vendorNameDetails.buyerID; }
    else if (vendorDetails.vendorID?.length) { fd.append("company_token", vendorDetails.vendorID); filters.company_token = vendorDetails.vendorID; }
    if (data.access_type === "User") { fd.append("user_token", buyer_token); fd.append("buyer_token", buyer_token); filters.user_token = buyer_token; filters.buyer_token = buyer_token; }
    else { fd.append("buyer_token", buyer_token); filters.buyer_token = buyer_token; }
    if (itemCode.item_token?.length) { fd.append("item_token", itemCode.item_token); filters.item_token = itemCode.item_token; }
    if (duration) { fd.append("month_period", duration); filters.month_period = duration; }
    else { if (fromDate.value) { fd.append("from_date", fromDate.value); filters.from_date = fromDate.value; } if (toDate.value) { fd.append("to_date", toDate.value); filters.to_date = toDate.value; } }
    setLoadingState(true);
    await axios({ method: "POST", url: `${API_ENDPOINT.new_buyer_dashbord}`, data: fd, headers: { Authorization: `Bearer ${auth_token}` }, timeout: DASHBOARD_REQUEST_TIMEOUT })
      .then((res) => {
        setLoadingState(false); const rd = res?.data;
        const dashboardRoot = rd?.response || {};
        setDashboardResponse(dashboardRoot);
        const prOrgToken = data?.org_token || data?.organization_token || data?.user?.token || buyer_token;
        if (prOrgToken) {
          void axios({
            method: "POST",
            url: `${API_ENDPOINT.get_pr_details_by_org_token}`,
            data: { org_token: prOrgToken },
            headers: { Authorization: `Bearer ${auth_token}` },
            timeout: DASHBOARD_REQUEST_TIMEOUT,
          })
            .then((prRes) => {
              const prRoot = prRes?.data?.response || prRes?.data || {};
              const prSection =
                prRoot?.dashboard1?.Module?.PR ||
                prRoot?.dashboard1?.PR ||
                prRoot?.Module?.PR ||
                prRoot?.PR ||
                prRoot;

              if (prSection && Object.keys(prSection || {}).length > 0) {
                setDashboardResponse((prev) => ({
                  ...(prev || dashboardRoot || {}),
                  dashboard1: {
                    ...((prev || dashboardRoot || {})?.dashboard1 || {}),
                    Module: {
                      ...((prev || dashboardRoot || {})?.dashboard1?.Module || {}),
                      PR: prSection,
                    },
                  },
                  budget_savings_analytics:
                    prRoot?.budget_savings_analytics ||
                    ((prev || dashboardRoot || {})?.budget_savings_analytics || {}),
                  location_wise_pr_raised:
                    prRoot?.location_wise_pr_raised ||
                    ((prev || dashboardRoot || {})?.location_wise_pr_raised || []),
                }));
              }
            })
            .catch(() => {});
        }
        const poRaw = rd?.["po data"] || {};
        const poStatusSummary = { approved: Number(poRaw?.Open ?? 0), pending: Number(poRaw?.Pending ?? 0), cancelled: Number(poRaw?.Cancel ?? 0) + Number(poRaw?.Closed ?? 0) };
        setAnalyticsData({
          totalPOValue: rd?.["total po value"], poTotal: rd?.["po total"],
          costSavingsMetric1: rd?.["first cost saving metric 1"], costSavingsMetric2: rd?.["first cost saving metric 2"],
          repeatPurchaseCostSavings: rd?.["repeat purchase cost saving"],
          pendingVsCloseRFQ: rd ? Object.values(rd["pending vs closed rfq"]) : [],
          submittedVsSelectedRFQ: rd ? Object.values(rd["submitted vs selected rfq"]) : [],
          purchaseOrderStatus: rd ? Object.values(rd["po status"]) : [],
          openCancelPending: rd ? [Number(poRaw?.Open ?? 0), Number(poRaw?.Pending ?? 0), Number(poRaw?.Cancel ?? 0) + Number(poRaw?.Closed ?? 0)] : [],
          totalRFQCreatedValueMonthWise: rd ? Object.values(rd["rfq monthly count"] || {}).reverse() : [],
          totalRFQCreatedLabelMonthWise: rd ? Object.keys(rd["rfq monthly count"] || {}) : [],
          totalRFQCreatedValueWeekWise: rd ? Object.values(weeklyReportObjFormate(rd["rfq weekly count"] || {})) : [],
          totalRFQCreatedLabelWeekWise: rd ? Object.keys(weeklyReportObjFormate(rd["rfq weekly count"] || {})) : [],
          totalPurchaseOrdersValueMonthWise: rd ? Object.values(rd["po value monthwise"] || {}).reverse() : [],
          totalPurchaseOrdersLabelMonthWise: rd ? Object.keys(rd["po value monthwise"] || {}) : [],
          totalPurchaseOrdersValueWeekWise: rd ? Object.values(weeklyReportObjFormate(rd["po weekly count"] || {})) : [],
          totalPurchaseOrdersLabelWeekWise: rd ? Object.keys(weeklyReportObjFormate(rd["po weekly count"] || {})) : [],
          totalSpentByItems: { labels: rd ? Object.keys(rd["item_spent"] || {}) : [], values: rd ? Object.values(rd["item_spent"] || {}) : [] },
          vendorResponseTime: { labels: rd ? Object.keys(rd["vendor_response_report"] || {}) : [], values: { maxTime: [rd ? Object.values(rd["vendor_response_report"] || {}).map(e => e?.max_response_time_hours) : []], minTime: [rd ? Object.values(rd["vendor_response_report"] || {}).map(e => e?.min_response_time_hours) : []] } },
          approverResponseTime: { labels: rd ? Object.keys(rd["approval_response_report"] || {}) : [], values: { maxTime: [rd ? Object.values(rd["approval_response_report"] || {}).map(e => e?.response_time_hours) : []], minTime: [rd ? Object.values(rd["approval_response_report"] || {}).map(e => e?.response_time_minutes) : []] } },
          poStatusSummary, topSelectedVendorsByRFQ: extractTopSelectedVendorsFromApi(rd),
        });
        getAllSpendItems(filters);
      })
      .catch((err) => { setLoadingState(false); console.log(err); })
      .finally(() => setHasLoadedDashboard(true));
  };

  const validateFilters = () => { const f = emptyCheck(fromDate?.value), t = emptyCheck(toDate?.value); setFromDate(p => ({ ...p, isValid: f })); setToDate(p => ({ ...p, isValid: t })); return f && t; };
  const handleFilterSearch = () => { if (!duration ? validateFilters() : true) getAnalyticsValues(); };

  useEffect(() => { if (!auth_token || !buyer_token) return; getAnalyticsValues(); }, [auth_token, buyer_token]);
  useEffect(() => {
    const id = setTimeout(() => { if (!isUserDashboard && pageNumber) getAllSpendItems(); }, 300);
    return () => clearTimeout(id);
  }, [isUserDashboard, pageNumber, searchQuery, sortingColumnName, sortingOrder]);

  const getAllSpendItems = async (filters = null) => { let payload = { buyer_token: org_token, page: pageNumber }; if (sortingColumnName?.trim()) { payload.sorting_column_name = sortingColumnName.trim(); payload.sorting_order = order; } if (searchQuery?.trim()) payload.search = searchQuery.trim(); if (filters && Object.keys(filters).length) payload = { ...payload, ...filters }; setSpendItemsLoading(true); await axios({ method: "POST", url: `${API_ENDPOINT.spend_item_view}`, data: payload, headers: { Authorization: `Bearer ${auth_token} ` }, timeout: DASHBOARD_REQUEST_TIMEOUT }).then((res) => { const { total_count, page_count, current_page_count } = res.data; setSpendItems(res?.data?.records); setPaginationData({ currentPage: pageNumber || 1, totalItems: total_count, current_page_count, page_count }); }).catch(console.log).finally(() => setSpendItemsLoading(false)); };
  const getAllVendorsData = async () => { await axios({ method: "POST", url: `${API_ENDPOINT.get_all_vendor}`, data: { org_token: buyer_token }, headers: { Authorization: `Bearer ${auth_token}` }, timeout: DASHBOARD_REQUEST_TIMEOUT }).then((res) => { const users = Array.isArray(res?.data?.users) ? res.data.users : []; const unique = Array.from(new Set(users.map(i => i.company_name))).map(cn => users.find(i => i.company_name === cn)); setVendorsList({ values: { tokens: unique.map(e => e?.token), visibleOption: [...new Set(users.map(e => e?.company_name + ""))] } }); setVendorTotalCount(Number(res?.data?.total_count || users.length || 0)); }).catch((err) => { console.log(err); setVendorTotalCount(0); }); };
  const resetSearch = () => { setVendorNameDetails({ buyerName: "", buyerID: "" }); setVendornameList({ values: { tokens: [null], visibleOption: ["No options"] } }); };
  const getvendorName = async (companyToken) => { resetSearch(); if (!companyToken || !companyToken.length) return; await axios({ method: "POST", url: `${API_ENDPOINT.vendor_company_list}`, data: { buyer_token, vendor_token: companyToken }, headers: { Authorization: `Bearer ${auth_token} ` }, timeout: DASHBOARD_REQUEST_TIMEOUT }).then((res) => { resetSearch(); const cl = res.data.response; const unique = Array.isArray(cl) ? Array.from(new Set(cl.map(i => i.full_name))).map(fn => cl.find(i => i.full_name === fn)) : []; setVendornameList({ values: { tokens: unique.map(e => e?.token), visibleOption: [...new Set(cl?.map(e => e?.full_name + ""))] } }); }).catch(() => setVendornameList({ values: { tokens: [null], visibleOption: ["No options"] } })); };
  const getAllItems = async () => { await axios({ method: "POST", url: `${API_ENDPOINT.view_all_item}`, data: { org_token }, headers: { Authorization: `Bearer ${auth_token} ` }, timeout: DASHBOARD_REQUEST_TIMEOUT }).then((res) => setItemList({ values: { tokens: res?.data?.response?.map(e => e?.token), visibleOption: res?.data?.response?.map(e => `${e?.item_name} - (${e?.item_code})`) } })).catch(() => setItemList({ values: { tokens: [null], visibleOption: ["No options"] } })); };

  const durationList = ["last month", "last 3 months", "last 6 months"];
  const bc = DASHBOARD_CHART_PALETTES.buyerDashboard;
  const uc = DASHBOARD_CHART_PALETTES.userDashboard;

  const executiveSnapshot = useMemo(() => getDashboardSection(dashboardResponse, "Executive Command Center", "Enterprise Procurement Snapshot"), [dashboardResponse]);
  const prIntelligence = useMemo(() => getDashboardSection(dashboardResponse, "Procurement Operations Control Tower", "PR Intelligence"), [dashboardResponse]);
  const rfqIntelligence = useMemo(() => getDashboardSection(dashboardResponse, "Procurement Operations Control Tower", "RFQ Intelligence"), [dashboardResponse]);
  const poIntelligence = useMemo(() => getDashboardSection(dashboardResponse, "Procurement Operations Control Tower", "PO Intelligence"), [dashboardResponse]);
  const vendorOnboardingAnalytics = useMemo(() => getDashboardSection(dashboardResponse, "Vendor & Onboarding Intelligence", "Vendor Onboarding Analytics"), [dashboardResponse]);
  const vendorPerformanceIntelligence = useMemo(() => getDashboardSection(dashboardResponse, "Vendor & Onboarding Intelligence", "Vendor Performance Intelligence"), [dashboardResponse]);
  const historicalSpendIntelligence = useMemo(() => getDashboardSection(dashboardResponse, "Strategic Sourcing Intelligence", "Historical Spend Intelligence"), [dashboardResponse]);
  const specificationIntelligence = useMemo(() => getDashboardSection(dashboardResponse, "Strategic Sourcing Intelligence", "Specification Intelligence"), [dashboardResponse]);
  const deliveryPerformance = useMemo(() => getDashboardSection(dashboardResponse, "Delivery & Logistics Intelligence", "Delivery Performance"), [dashboardResponse]);
  const grnIntelligence = useMemo(() => getDashboardSection(dashboardResponse, "GRN, Invoice & 3-Way Matching Intelligence", "GRN Intelligence"), [dashboardResponse]);
  const invoiceIntelligence = useMemo(() => getDashboardSection(dashboardResponse, "GRN, Invoice & 3-Way Matching Intelligence", "Invoice Intelligence"), [dashboardResponse]);
  const matchingIntelligence = useMemo(() => getDashboardSection(dashboardResponse, "GRN, Invoice & 3-Way Matching Intelligence", "3-Way Matching Intelligence"), [dashboardResponse]);
  const riskCompliance = useMemo(() => getDashboardSection(dashboardResponse, "Risk & Compliance Intelligence"), [dashboardResponse]);
  const executiveKpiLayer = useMemo(() => getDashboardSection(dashboardResponse, "Executive Procurement KPI Layer", "Enterprise Procurement KPIs"), [dashboardResponse]);

  const executiveKpiCards = useMemo(() => ([
    {
      title: "Total Spend Under Management",
      value: executiveSnapshot?.["Total Spend Under Management"] ?? "0",
      note: "Enterprise procurement snapshot",
      accent: "#0f766e",
      onClick: () => navigate("/Buyer_dashboard/PO"),
    },
    {
      title: "Total Savings Achieved",
      value: executiveSnapshot?.["Total Savings Achieved"] ?? "0",
      note: "Cross-year procurement savings",
      accent: "#2563eb",
      onClick: () => navigate("/Buyer_dashboard/Items"),
    },
    {
      title: "Savings %",
      value: formatPercent(executiveSnapshot?.["Savings %"] ?? 0),
      note: "Plan-vs-actual efficiency",
      accent: "#059669",
      onClick: () => navigate("/Buyer_dashboard/Items"),
    },
    {
      title: "Active RFQs",
      value: executiveSnapshot?.["Active RFQs"] ?? 0,
      note: "Live sourcing activities",
      accent: "#7c3aed",
      onClick: () => navigate("/Buyer_dashboard/RFQ"),
    },
    {
      title: "Active POs",
      value: executiveSnapshot?.["Active POs"] ?? 0,
      note: "Open purchase orders",
      accent: "#d97706",
      onClick: () => navigate("/Buyer_dashboard/PO"),
    },
    {
      title: "Pending Approvals",
      value: executiveSnapshot?.["Pending Approvals"] ?? 0,
      note: "Pending workflow actions",
      accent: "#dc2626",
      onClick: () => navigate("/Buyer_dashboard/PO", { state: { status: "waitingForApproval" } }),
    },
    {
      title: "Pending GRNs",
      value: executiveSnapshot?.["Pending GRNs"] ?? 0,
      note: "Receiving backlog",
      accent: "#0891b2",
      onClick: () => navigate("/GRN_Dashboard/GRN"),
    },
    {
      title: "Pending Invoices",
      value: executiveSnapshot?.["Pending Invoices"] ?? 0,
      note: "Invoice processing queue",
      accent: "#4f46e5",
      onClick: () => navigate("/Buyer_dashboard/Invoice"),
    },
    {
      title: "Supplier Performance Index",
      value: executiveKpiLayer?.["Vendor Performance Index"] ?? 0,
      note: "Executive KPI layer",
      accent: "#16a34a",
      onClick: () => navigate("/Buyer_dashboard/Vendors"),
    },
    {
      title: "Procurement Risk Score",
      value: executiveKpiLayer?.["Procurement Risk Score"] ?? 0,
      note: "Risk intelligence layer",
      accent: "#ea580c",
      onClick: () => navigate("/Buyer_dashboard/Vendors"),
    },
  ]), [executiveKpiLayer, executiveSnapshot, navigate]);

  /* â”€â”€ Derived values (UNCHANGED) â”€â”€ */
  const submittedAndSelectedDataValue = useMemo(() => (
    Array.isArray(analyticsData?.submittedVsSelectedRFQ) && analyticsData.submittedVsSelectedRFQ.length
      ? analyticsData.submittedVsSelectedRFQ
      : [0, 0, 0, 0]
  ), [analyticsData?.submittedVsSelectedRFQ]);

  const rfqTotal = useMemo(() => (
    (submittedAndSelectedDataValue[1] || 0) +
    (submittedAndSelectedDataValue[2] || 0) +
    (submittedAndSelectedDataValue[3] || 0)
  ), [submittedAndSelectedDataValue]);

  const pendingAndClosedRFQDataValues = useMemo(() => (
    Array.isArray(analyticsData?.pendingVsCloseRFQ) && analyticsData.pendingVsCloseRFQ.length
      ? analyticsData.pendingVsCloseRFQ
      : [0, 0]
  ), [analyticsData?.pendingVsCloseRFQ]);
  const openCancelPendingDataValue = useMemo(() => { const d = analyticsData?.openCancelPending; if (Array.isArray(d) && d.some(v => v > 0)) return d; const s = analyticsData?.poStatusSummary; return s ? [Number(s.approved || 0), Number(s.pending || 0), Number(s.cancelled || 0)] : [0, 0, 0]; }, [analyticsData?.openCancelPending, analyticsData?.poStatusSummary]);
  const raisedPRTotal = raisedPRSummary?.total ?? 0;
  const overallPRValues = useMemo(() => (
    prSummaryOverride
      ? [prSummaryOverride.approved || 0, prSummaryOverride.rejected || 0, prSummaryOverride.pending || 0]
      : [0, 0, 0]
  ), [prSummaryOverride]);
  const grnSummaryValues = useMemo(() => { let o = 0, c = 0; (grns || []).forEach((g) => { const s = String(g?.overall_approval_status ?? g?.status ?? "").toLowerCase(); if (g?.status === true || ["true", "closed", "completed", "approved"].includes(s)) c++; else o++; }); return [o, c]; }, [grns]);
  const twmSummaryValues = useMemo(() => { let a = 0, p = 0, ir = 0, r = 0; (twmList || []).forEach((t) => { const s = String(t?.status || "").toUpperCase(); if (s === "APPROVED") a++; else if (s === "PENDING") p++; else if (s === "IN_REVIEW") ir++; else if (s === "REJECTED") r++; }); return [a, p, ir, r]; }, [twmList]);
  const twmApprovedRejectedValues = useMemo(() => [twmSummaryValues[0] || 0, twmSummaryValues[3] || 0], [twmSummaryValues]);
  const merchantInvoiceValues = useMemo(() => { const is = merchantInvoiceSummary?.invoice_status_summary || {}; return [Number(is?.approved || 0), Number(is?.signed || 0), Number(is?.unsigned || 0), Number(is?.rejected || 0)]; }, [merchantInvoiceSummary]);
  const merchantInvoiceApprovedRejectedValues = useMemo(() => [merchantInvoiceValues[0] || 0, merchantInvoiceValues[3] || 0], [merchantInvoiceValues]);
  const orgInvoiceTotal = useMemo(() => merchantInvoiceValues.reduce((s, v) => s + (Number(v) || 0), 0), [merchantInvoiceValues]);
  const quotationSummaryValues = useMemo(() => [Number(submittedAndSelectedDataValue?.[0] || 0), Number(submittedAndSelectedDataValue?.[3] || 0)], [submittedAndSelectedDataValue]);
  const vendorOnboardingTrend = useMemo(() => { const trend = merchantInvoiceSummary?.vendor_onboard_trend || {}; const initiated = Array.isArray(trend?.initiated) ? trend.initiated : []; const onboarded = Array.isArray(trend?.onboarded) ? trend.onboarded : []; const dates = [...new Set([...initiated.map(i => i?.date), ...onboarded.map(i => i?.date)].filter(Boolean))].sort((a, b) => new Date(a) - new Date(b)); const im = Object.fromEntries(initiated.map(i => [i?.date, Number(i?.count || 0)])); const om = Object.fromEntries(onboarded.map(i => [i?.date, Number(i?.count || 0)])); if (!dates.length) return { labels: ["No Data"], initiatedValues: [0], onboardedValues: [0] }; return { labels: dates, initiatedValues: dates.map(d => im[d] || 0), onboardedValues: dates.map(d => om[d] || 0) }; }, [merchantInvoiceSummary]);
  const topSelectedVendorsByRFQ = useMemo(() => { const counter = {}; (rfqs || []).forEach((rfq) => { const vl = Array.isArray(rfq?.rfq_vendor_list) ? rfq.rfq_vendor_list : Array.isArray(rfq?.vendors) ? rfq.vendors : []; const seen = new Set(); vl.forEach((v) => { const name = String(v?.vendor || v?.vendor_name || v?.company_name || v?.supplier_name || v?.first_name || "").replace(/\s+/g, " ").trim(); if (!name || seen.has(name.toLowerCase())) return; seen.add(name.toLowerCase()); counter[name] = (counter[name] || 0) + 1; }); }); const fromRFQ = Object.entries(counter).map(([l, v]) => ({ label: l, value: v })).sort((a, b) => b.value - a.value).slice(0, 8); if (fromRFQ.length) return fromRFQ; return [{ label: "No Vendors", value: 0 }]; }, [analyticsData?.topSelectedVendorsByRFQ, rfqs]);
  const vendorSummaryValues = useMemo(() => { const total = Number(vendorTotalCount) || 0; const sel = topSelectedVendorsByRFQ.filter(i => Number(i?.value || 0) > 0).length; return [sel, Math.max(total - sel, 0)]; }, [vendorTotalCount, topSelectedVendorsByRFQ]);
  const topSelectedVendorsLabels = useMemo(() => topSelectedVendorsByRFQ.map(i => i.label), [topSelectedVendorsByRFQ]);
  const topSelectedVendorsValues = useMemo(() => topSelectedVendorsByRFQ.map(i => i.value), [topSelectedVendorsByRFQ]);
  const grnApprovedRejectedValues = useMemo(() => { let a = 0, r = 0; (grns || []).forEach((g) => { const s = String(g?.overall_approval_status ?? g?.status ?? "").toLowerCase(); if (s.includes("reject")) r++; else if (s.includes("approve") || s === "approved" || g?.status === true) a++; }); return [a, r]; }, [grns]);
  const poSummaryValues = useMemo(() => { const s = analyticsData?.poStatusSummary || {}; return [Number(s.approved || 0), Number(s.rejected || 0), Number(s.pending || 0)]; }, [analyticsData?.poStatusSummary]);
  const purchaseOrderData = poSummaryValues;

  const prApprovalStatusValues = useMemo(() => ([
    normalizeMetricValue(prIntelligence?.["PR Approval Status"]?.Approved),
    normalizeMetricValue(prIntelligence?.["PR Approval Status"]?.Pending),
    normalizeMetricValue(prIntelligence?.["PR Approval Status"]?.Rejected),
  ]), [prIntelligence]);

  const rfqOpenClosedValues = useMemo(() => ([
    normalizeMetricValue(rfqIntelligence?.["Open vs Closed RFQs"]?.Open),
    normalizeMetricValue(rfqIntelligence?.["Open vs Closed RFQs"]?.Closed),
  ]), [rfqIntelligence]);

  const rfqOverviewChart = useMemo(() => mapObjectToChart({
    "RFQs Floated": rfqIntelligence?.["RFQs Floated"],
    "Vendors Invited": rfqIntelligence?.["Vendors Invited"],
    "Quotations Received": rfqIntelligence?.["Quotations Received"],
    "Quote Revision Tracking": rfqIntelligence?.["Quote Revision Tracking"],
    "Unresponsive Vendors": rfqIntelligence?.["Unresponsive Vendors"],
  }, 5), [rfqIntelligence]);

  const poApprovalWorkflowValues = useMemo(() => ([
    normalizeMetricValue(poIntelligence?.["PO Approval Workflow"]?.Pending),
    normalizeMetricValue(poIntelligence?.["PO Approval Workflow"]?.Closed),
  ]), [poIntelligence]);

  const poOverviewChart = useMemo(() => mapObjectToChart({
    "POs Released": poIntelligence?.["POs Released"],
    "Delayed PO Approvals": poIntelligence?.["Delayed PO Approvals"],
    "Cancelled POs": poIntelligence?.["Cancelled POs"],
    "Rate Contract to PO Conversion": poIntelligence?.["Rate Contract to PO Conversion"],
    "Off-Contract Purchases": poIntelligence?.["Off-Contract Purchases"],
  }, 5), [poIntelligence]);

  const vendorOnboardingValues = useMemo(() => ([
    normalizeMetricValue(vendorOnboardingAnalytics?.["Initiated vs Completed"]?.Initiated),
    normalizeMetricValue(vendorOnboardingAnalytics?.["Initiated vs Completed"]?.Completed),
  ]), [vendorOnboardingAnalytics]);

  const panVerificationValues = useMemo(() => ([
    normalizeMetricValue(vendorOnboardingAnalytics?.["PAN Verification"]?.Success),
    normalizeMetricValue(vendorOnboardingAnalytics?.["PAN Verification"]?.Failed),
    normalizeMetricValue(vendorOnboardingAnalytics?.["PAN Verification"]?.Skipped),
    normalizeMetricValue(vendorOnboardingAnalytics?.["PAN Verification"]?.["Pending / Not Verified"]),
  ]), [vendorOnboardingAnalytics]);

  const gstVerificationValues = useMemo(() => ([
    normalizeMetricValue(vendorOnboardingAnalytics?.["GST Validation"]?.Success),
    normalizeMetricValue(vendorOnboardingAnalytics?.["GST Validation"]?.Failed),
    normalizeMetricValue(vendorOnboardingAnalytics?.["GST Validation"]?.Skipped),
    normalizeMetricValue(vendorOnboardingAnalytics?.["GST Validation"]?.["Pending / Not Verified"]),
  ]), [vendorOnboardingAnalytics]);

  const bankVerificationValues = useMemo(() => ([
    normalizeMetricValue(vendorOnboardingAnalytics?.["Bank Account Validation"]?.Success),
    normalizeMetricValue(vendorOnboardingAnalytics?.["Bank Account Validation"]?.Failed),
    normalizeMetricValue(vendorOnboardingAnalytics?.["Bank Account Validation"]?.Skipped),
    normalizeMetricValue(vendorOnboardingAnalytics?.["Bank Account Validation"]?.["Pending / Not Verified"]),
  ]), [vendorOnboardingAnalytics]);

  const vendorScorecardChart = useMemo(() => {
    const scorecard = Array.isArray(vendorPerformanceIntelligence?.["Vendor Scorecard"]) ? vendorPerformanceIntelligence["Vendor Scorecard"] : [];
    return {
      labels: scorecard.map((item) => item?.vendor__company_name || "").filter(Boolean),
      values: scorecard.map((item) => normalizeMetricValue(item?.selected_count)),
    };
  }, [vendorPerformanceIntelligence]);

  const categorySpendChart = useMemo(() => mapArrayToChart(historicalSpendIntelligence?.["Category-wise Spend"], "name", "amount", 6), [historicalSpendIntelligence]);
  const vendorSpendChart = useMemo(() => mapArrayToChart(historicalSpendIntelligence?.["Vendor-wise Spend"], "name", "amount", 6), [historicalSpendIntelligence]);
  const capexOpexValues = useMemo(() => ([
    normalizeMetricValue(historicalSpendIntelligence?.["CAPEX vs OPEX"]?.Unmapped),
    normalizeMetricValue(historicalSpendIntelligence?.["CAPEX vs OPEX"]?.CapEx),
    normalizeMetricValue(historicalSpendIntelligence?.["CAPEX vs OPEX"]?.["Multiple Items"]),
    normalizeMetricValue(historicalSpendIntelligence?.["CAPEX vs OPEX"]?.OpEx),
  ]), [historicalSpendIntelligence]);

  const quantityTrendChart = useMemo(() => mapArrayToChart(specificationIntelligence?.["Quantity Trend"], "item_name", "total", 8), [specificationIntelligence]);

  const deliveryValues = useMemo(() => ([
    normalizeMetricValue(deliveryPerformance?.["On-Time Deliveries"]),
    normalizeMetricValue(deliveryPerformance?.["Delayed Deliveries"]),
    normalizeMetricValue(deliveryPerformance?.["Overdue POs"]),
    normalizeMetricValue(deliveryPerformance?.["Delivery SLA Breach"]),
  ]), [deliveryPerformance]);

  const grnValues = useMemo(() => ([
    normalizeMetricValue(grnIntelligence?.["Open GRNs"]),
    normalizeMetricValue(grnIntelligence?.["Closed GRNs"]),
    normalizeMetricValue(grnIntelligence?.["Delayed GRNs"]),
    normalizeMetricValue(grnIntelligence?.["GRN Exception Analysis"]),
  ]), [grnIntelligence]);

  const invoiceValues = useMemo(() => ([
    normalizeMetricValue(invoiceIntelligence?.["Invoice Uploaded"]),
    normalizeMetricValue(invoiceIntelligence?.["Invoice Validation"]),
    normalizeMetricValue(invoiceIntelligence?.["Duplicate Invoice Detection"]),
    normalizeMetricValue(invoiceIntelligence?.["Invoice Mismatch Detection"]),
  ]), [invoiceIntelligence]);

  const matchingValues = useMemo(() => ([
    normalizeMetricValue(matchingIntelligence?.["Matched Invoices"]),
    normalizeMetricValue(matchingIntelligence?.["Blocked Invoices"]),
    normalizeMetricValue(matchingIntelligence?.["Pending Matching"]),
  ]), [matchingIntelligence]);

  const complianceMonitoringChart = useMemo(() => mapObjectToChart({
    "GST Compliance": riskCompliance?.["Compliance Monitoring"]?.["GST Compliance"],
    "MSME Compliance": riskCompliance?.["Compliance Monitoring"]?.["MSME Compliance"],
    "CIN Status": riskCompliance?.["Compliance Monitoring"]?.["CIN Status"],
    "Expired Documents": riskCompliance?.["Compliance Monitoring"]?.["Expired Documents"],
    "Regulatory Risk": riskCompliance?.["Compliance Monitoring"]?.["Regulatory Risk"],
  }, 5), [riskCompliance]);

  const procurementRiskChart = useMemo(() => mapObjectToChart({
    "Single Vendor Dependency": riskCompliance?.["Procurement Risk Intelligence"]?.["Single Vendor Dependency"],
    "Price Spike Alerts": riskCompliance?.["Procurement Risk Intelligence"]?.["Price Spike Alerts"],
    "Abnormal Purchase Quantity": riskCompliance?.["Procurement Risk Intelligence"]?.["Abnormal Purchase Quantity"],
    "Emergency Buying Pattern": riskCompliance?.["Procurement Risk Intelligence"]?.["Emergency Buying Pattern"],
    "Contract Leakage": riskCompliance?.["Procurement Risk Intelligence"]?.["Contract Leakage"],
  }, 5), [riskCompliance]);

  /* â”€â”€ Year/Month options â”€â”€ */
  const prMonthOptions = [{ label: "All Months", value: "all" }, { label: "January", value: 0 }, { label: "February", value: 1 }, { label: "March", value: 2 }, { label: "April", value: 3 }, { label: "May", value: 4 }, { label: "June", value: 5 }, { label: "July", value: 6 }, { label: "August", value: 7 }, { label: "September", value: 8 }, { label: "October", value: 9 }, { label: "November", value: 10 }, { label: "December", value: 11 }];
  const prYearOptions = useMemo(() => { const cy = new Date().getFullYear(); const y = []; for (let i = orgCreatedYear; i <= cy; i++)y.push(i); return y; }, [orgCreatedYear]);
  const parseDateKey = (k) => { const d = new Date(k); return isNaN(d.getTime()) ? null : { year: d.getFullYear(), month: d.getMonth() }; };
  const parseWeeklyLabel = (l) => { const m = String(l || "").match(/^([A-Za-z]{3})\s(\d{2})/); if (!m) return null; const mm = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11 }; return { year: 2000 + Number(m[2]), month: mm[m[1]] }; };
  const rfqYearOptions = useMemo(() => { const y = new Set(); (analyticsData?.totalRFQCreatedLabelMonthWise || []).forEach(l => { const p = parseDateKey(l); if (p) y.add(p.year); }); const s = Array.from(y).sort((a, b) => a - b); return s.length ? s : [new Date().getFullYear()]; }, [analyticsData?.totalRFQCreatedLabelMonthWise]);
  const poYearOptions = useMemo(() => { const y = new Set(); (analyticsData?.totalPurchaseOrdersLabelMonthWise || []).forEach(l => { const p = parseDateKey(l); if (p) y.add(p.year); }); const s = Array.from(y).sort((a, b) => a - b); return s.length ? s : [new Date().getFullYear()]; }, [analyticsData?.totalPurchaseOrdersLabelMonthWise]);
  useEffect(() => { if (!rfqYearOptions.includes(Number(rfqChartYear))) setRfqChartYear(rfqYearOptions[0]); }, [rfqYearOptions, rfqChartYear]);
  useEffect(() => { if (!poYearOptions.includes(Number(poChartYear))) setPoChartYear(poYearOptions[0]); }, [poYearOptions, poChartYear]);
  const filterMonthly = (labels, values, year) => { const fl = [], fv = []; (labels || []).forEach((l, i) => { const p = parseDateKey(l); if (p && p.year === Number(year)) { fl.push(l); fv.push((values || [])[i] ?? 0); } }); return { labels: fl, values: fv }; };
  const filterWeekly = (labels, values, year, month) => { const fl = [], fv = []; (labels || []).forEach((l, i) => { const p = parseWeeklyLabel(l); if (!p || p.year !== Number(year)) return; if (month !== "all" && p.month !== Number(month)) return; fl.push(l); fv.push((values || [])[i] ?? 0); }); return { labels: fl, values: fv }; };
  const rfqChartDuration = rfqChartMonth === "all" ? "monthly" : "weekly";
  const rfqFiltered = useMemo(() => (
    rfqChartDuration === "monthly"
      ? filterMonthly(analyticsData?.totalRFQCreatedLabelMonthWise, analyticsData?.totalRFQCreatedValueMonthWise, rfqChartYear)
      : filterWeekly(analyticsData?.totalRFQCreatedLabelWeekWise, analyticsData?.totalRFQCreatedValueWeekWise, rfqChartYear, rfqChartMonth)
  ), [
    rfqChartDuration,
    rfqChartYear,
    rfqChartMonth,
    analyticsData?.totalRFQCreatedLabelMonthWise,
    analyticsData?.totalRFQCreatedValueMonthWise,
    analyticsData?.totalRFQCreatedLabelWeekWise,
    analyticsData?.totalRFQCreatedValueWeekWise,
  ]);

  const poChartDuration = poChartMonth === "all" ? "monthly" : "weekly";
  const poFiltered = useMemo(() => (
    poChartDuration === "monthly"
      ? filterMonthly(analyticsData?.totalPurchaseOrdersLabelMonthWise, analyticsData?.totalPurchaseOrdersValueMonthWise, poChartYear)
      : filterWeekly(analyticsData?.totalPurchaseOrdersLabelWeekWise, analyticsData?.totalPurchaseOrdersValueWeekWise, poChartYear, poChartMonth)
  ), [
    poChartDuration,
    poChartYear,
    poChartMonth,
    analyticsData?.totalPurchaseOrdersLabelMonthWise,
    analyticsData?.totalPurchaseOrdersValueMonthWise,
    analyticsData?.totalPurchaseOrdersLabelWeekWise,
    analyticsData?.totalPurchaseOrdersValueWeekWise,
  ]);

  /* â”€â”€ Dataset builders â”€â”€ */
  const mk = (heading, text, labels, colors, indicators, lines, onSeg) => ({ cardHeading: heading, chartText: text, chartLabels: labels, barColors: colors, chartIndicators: indicators, progressLines: lines, onSegmentClick: onSeg });
  const centreText = (t, v) => <span style={{ fontSize: "13px", fontFamily: '"gilroyBold",Inter,sans-serif', color: "#111827", lineHeight: 1.3 }}>{t}<br />{v}</span>;

  const buyerPRDataSet = useMemo(() => mk(
    "PR Approval",
    centreText("Total PR", prSummaryOverride?.total || 0),
    ["Approved Requisitions", "Rejected Requisitions", "Requisitions Pending Approval"],
    [bc.prSummary?.[0] || "#3B82F6", bc.prSummary?.[1] || "#ef4444", bc.prSummary?.[2] || "#93C5FD"],
    [
      { value: "Approved", color: bc.prSummary?.[0] || "#3B82F6", onClick: () => navigate("/Buyer_dashboard/PR", { state: { status: "approved" } }) },
      { value: "Rejected", color: bc.prSummary?.[1] || "#ef4444", onClick: () => navigate("/Buyer_dashboard/PR", { state: { status: "rejected" } }) },
      { value: "Pending", color: bc.prSummary?.[2] || "#93C5FD", onClick: () => navigate("/Buyer_dashboard/PR", { state: { status: "pending" } }) },
    ],
    [
      { label: "Approved Requisitions", value: overallPRValues[0] || 0, color: bc.prSummary?.[0] || "#3B82F6", onClick: () => navigate("/Buyer_dashboard/PR", { state: { status: "approved" } }) },
      { label: "Rejected Requisitions", value: overallPRValues[1] || 0, color: bc.prSummary?.[1] || "#ef4444", onClick: () => navigate("/Buyer_dashboard/PR", { state: { status: "rejected" } }) },
      { label: "Requisitions Pending Approval", value: overallPRValues[2] || 0, color: bc.prSummary?.[2] || "#93C5FD", onClick: () => navigate("/Buyer_dashboard/PR", { state: { status: "pending" } }) },
    ],
    (i) => navigate("/Buyer_dashboard/PR", { state: { status: ["approved", "rejected", "pending"][i] || "all" } })
  ), [bc.prSummary, navigate, overallPRValues, prSummaryOverride?.total]);

  const submittedDataSet = useMemo(() => ({
    ...mk(
      "Submitted and Selected RFQ",
      centreText("Total Sourcing Events", rfqTotal),
      ["Submitted", "Selected", "Unselected", "Unsubmitted"],
      bc.submittedSelected,
      [
        { value: "Submitted", color: bc.submittedSelected[0] },
        { value: "Selected", color: bc.submittedSelected[1] },
        { value: "Unselected", color: bc.submittedSelected[2] },
        { value: "Unsubmitted", color: bc.submittedSelected[3] },
      ],
      [
        { label: "Submitted RFQ", value: submittedAndSelectedDataValue[0] || 0, color: bc.submittedSelected[0] },
        { label: "Selected RFQ", value: submittedAndSelectedDataValue[1] || 0, color: bc.submittedSelected[1] },
        { label: "Unselected RFQ", value: submittedAndSelectedDataValue[2] || 0, color: bc.submittedSelected[2] },
        { label: "Unsubmitted RFQ", value: submittedAndSelectedDataValue[3] || 0, color: bc.submittedSelected[3] },
      ]
    ),
    indicatorPlacement: "below",
    indicatorColumns: 2,
  }), [bc.submittedSelected, rfqTotal, submittedAndSelectedDataValue]);

  const pendingClosedDataSet = useMemo(() => ({
    ...mk(
      "Pending and Closed RFQ",
      centreText("Total Sourcing Events", pendingAndClosedRFQDataValues[0] + pendingAndClosedRFQDataValues[1]),
      ["Pending", "Closed"],
      bc.pendingClosedRfq,
      [
        { value: "Pending", color: bc.pendingClosedRfq[0] },
        { value: "Closed", color: bc.pendingClosedRfq[1] },
      ],
      [
        { label: "RFQs Awaiting Action", value: pendingAndClosedRFQDataValues[0] || 0, color: bc.pendingClosedRfq[0] },
        { label: "Completed Sourcing Events", value: pendingAndClosedRFQDataValues[1] || 0, color: bc.pendingClosedRfq[1] },
      ]
    ),
    indicatorPlacement: "below",
    indicatorColumns: 2,
  }), [bc.pendingClosedRfq, pendingAndClosedRFQDataValues]);

  const quotationDataSet = useMemo(() => mk(
    "Quotation Summary",
    centreText("Quotes", quotationSummaryValues[0] || 0),
    ["Received", "Pending"],
    bc.quotationSummary,
    [
      { value: "Quotes Received", color: bc.quotationSummary[0] },
      { value: "Pending Quotes", color: bc.quotationSummary[1] },
    ],
    [
      { label: "Quotes Received", value: quotationSummaryValues[0] || 0, color: bc.quotationSummary[0] },
      { label: "Pending Quotes", value: quotationSummaryValues[1] || 0, color: bc.quotationSummary[1] },
    ]
  ), [bc.quotationSummary, quotationSummaryValues]);

  const poApprovalDataSet = useMemo(() => mk(
    "PO Approval",
    centreText("Total PO", (openCancelPendingDataValue || []).reduce((s, v) => s + (Number(v) || 0), 0)),
    ["Approved", "Waiting", "Cancelled"],
    [bc.poSummary[0], bc.poSummary[1], bc.openCancelPending[0]],
    [
      { value: "Approved", color: bc.poSummary[0], onClick: () => navigate("/Buyer_dashboard/PO", { state: { status: "Approved" } }) },
      { value: "Waiting", color: bc.poSummary[1], onClick: () => navigate("/Buyer_dashboard/PO", { state: { status: "waitingForApproval" } }) },
      { value: "Cancelled", color: bc.openCancelPending[0], onClick: () => navigate("/Buyer_dashboard/PO", { state: { status: "Cancelled" } }) },
    ],
    [
      { label: "Approved", value: openCancelPendingDataValue[0] || 0, color: bc.poSummary[0], onClick: () => navigate("/Buyer_dashboard/PO", { state: { status: "Approved" } }) },
      { label: "Waiting for Approval", value: openCancelPendingDataValue[1] || 0, color: bc.poSummary[1], onClick: () => navigate("/Buyer_dashboard/PO", { state: { status: "waitingForApproval" } }) },
      { label: "Cancelled", value: openCancelPendingDataValue[2] || 0, color: bc.openCancelPending[0], onClick: () => navigate("/Buyer_dashboard/PO", { state: { status: "Cancelled" } }) },
    ],
    (i) => navigate("/Buyer_dashboard/PO", { state: { status: ["Approved", "waitingForApproval", "Cancelled"][i] } })
  ), [bc.openCancelPending, bc.poSummary, navigate, openCancelPendingDataValue]);

  const vendorSummaryDataSet = useMemo(() => ({
    ...mk(
      "Vendor Summary",
      centreText(Number(vendorTotalCount) || 0, "Total"),
      ["Invited", "Others"],
      bc.vendorSummary,
      [
        { value: "Invited", color: bc.vendorSummary[0] },
        { value: "Others", color: bc.vendorSummary[1] },
      ],
      [
        { label: "Invited", value: vendorSummaryValues[0] || 0, color: bc.vendorSummary[0] },
        { label: "Others", value: vendorSummaryValues[1] || 0, color: bc.vendorSummary[1] },
      ]
    ),
    indicatorPlacement: "below",
    indicatorColumns: 2,
  }), [bc.vendorSummary, vendorSummaryValues, vendorTotalCount]);

  const grnDataSet = useMemo(() => mk(
    "GRN Summary",
    centreText((grnSummaryValues[0] || 0) + (grnSummaryValues[1] || 0), "Total GRN"),
    ["Open", "Closed"],
    bc.grnSummary,
    [
      { value: "Open GRN", color: bc.grnSummary[0] },
      { value: "Closed GRN", color: bc.grnSummary[1] },
    ],
    [
      { label: "Open GRN", value: grnSummaryValues[0] || 0, color: bc.grnSummary[0] },
      { label: "Closed GRN", value: grnSummaryValues[1] || 0, color: bc.grnSummary[1] },
    ]
  ), [bc.grnSummary, grnSummaryValues]);

  const twmDataSet = useMemo(() => mk(
    "Three-Way Matching",
    centreText((twmSummaryValues || []).reduce((s, v) => s + v, 0), "Total"),
    ["Approved", "Pending", "In Review", "Rejected"],
    bc.twmSummary,
    [
      { value: "Approved", color: bc.twmSummary[0] },
      { value: "Pending", color: bc.twmSummary[1] },
      { value: "In Review", color: bc.twmSummary[2] },
      { value: "Rejected", color: bc.twmSummary[3] },
    ],
    [
      { label: "Approved", value: twmSummaryValues[0] || 0, color: bc.twmSummary[0] },
      { label: "Pending", value: twmSummaryValues[1] || 0, color: bc.twmSummary[1] },
      { label: "In Review", value: twmSummaryValues[2] || 0, color: bc.twmSummary[2] },
      { label: "Rejected", value: twmSummaryValues[3] || 0, color: bc.twmSummary[3] },
    ]
  ), [bc.twmSummary, twmSummaryValues]);

  const merchantDataSet = useMemo(() => mk(
    "Merchant Invoice",
    centreText((merchantInvoiceValues || []).reduce((s, v) => s + v, 0), "Total"),
    ["Approved", "Signed", "Unsigned", "Rejected"],
    bc.merchantInvoiceSummary,
    [
      { value: "Approved", color: bc.merchantInvoiceSummary[0] },
      { value: "Signed", color: bc.merchantInvoiceSummary[1] },
      { value: "Unsigned", color: bc.merchantInvoiceSummary[2] },
      { value: "Rejected", color: bc.merchantInvoiceSummary[3] },
    ],
    [
      { label: "Approved", value: merchantInvoiceValues[0] || 0, color: bc.merchantInvoiceSummary[0] },
      { label: "Signed", value: merchantInvoiceValues[1] || 0, color: bc.merchantInvoiceSummary[1] },
      { label: "Unsigned", value: merchantInvoiceValues[2] || 0, color: bc.merchantInvoiceSummary[2] },
      { label: "Rejected", value: merchantInvoiceValues[3] || 0, color: bc.merchantInvoiceSummary[3] },
    ]
  ), [bc.merchantInvoiceSummary, merchantInvoiceValues]);

  const orgPRDataSet = useMemo(() => (
    { ...buyerPRDataSet, onSegmentClick: (i) => navigate("/User_dashboard/PR", { state: { status: ["approved", "rejected", "pending"][i] || "all" } }) }
  ), [buyerPRDataSet, navigate]);

  const poUserDataSet = useMemo(() => mk(
    "PO Approval",
    centreText((purchaseOrderData || []).reduce((s, v) => s + v, 0), "Purchase Orders Released"),
    ["Approved", "Rejected", "Pending"],
    uc.poSummary,
    [
      { value: "Approved", color: uc.poSummary[0], onClick: () => navigate("/User_dashboard/PO", { state: { status: "approved" } }) },
      { value: "Rejected", color: uc.poSummary[1], onClick: () => navigate("/User_dashboard/PO", { state: { status: "rejected" } }) },
      { value: "Pending", color: uc.poSummary[2], onClick: () => navigate("/User_dashboard/PO", { state: { status: "waiting for approval" } }) },
    ],
    [
      { label: "Approved", value: purchaseOrderData[0] || 0, color: uc.poSummary[0] },
      { label: "Rejected", value: purchaseOrderData[1] || 0, color: uc.poSummary[1] },
      { label: "Pending", value: purchaseOrderData[2] || 0, color: uc.poSummary[2] },
    ],
    (i) => navigate("/User_dashboard/PO", { state: { status: ["approved", "rejected", "waiting for approval"][i] || "" } })
  ), [navigate, purchaseOrderData, uc.poSummary]);

  const twmUserDataSet = useMemo(() => (
    isFinanceUser
      ? mk(
        "Three-Way Matching",
        centreText((twmApprovedRejectedValues || []).reduce((s, v) => s + v, 0), "Total"),
        ["Approved", "Rejected"],
        uc.approvedRejected,
        [
          { value: "Approved", color: uc.approvedRejected[0] },
          { value: "Rejected", color: uc.approvedRejected[1] },
        ],
        [
          { label: "Approved", value: twmApprovedRejectedValues[0] || 0, color: uc.approvedRejected[0] },
          { label: "Rejected", value: twmApprovedRejectedValues[1] || 0, color: uc.approvedRejected[1] },
        ]
      )
      : twmDataSet
  ), [isFinanceUser, twmApprovedRejectedValues, twmDataSet, uc.approvedRejected]);

  const grnUserDataSet = useMemo(() => (
    (isStoreExecutive || isStoreManager)
      ? mk(
        "GRN Summary",
        centreText((grnApprovedRejectedValues || []).reduce((s, v) => s + v, 0), "Total"),
        ["Approved", "Rejected"],
        uc.approvedRejected,
        [
          { value: "Approved", color: uc.approvedRejected[0] },
          { value: "Rejected", color: uc.approvedRejected[1] },
        ],
        [
          { label: "Approved", value: grnApprovedRejectedValues[0] || 0, color: uc.approvedRejected[0] },
          { label: "Rejected", value: grnApprovedRejectedValues[1] || 0, color: uc.approvedRejected[1] },
        ]
      )
      : grnDataSet
  ), [grnApprovedRejectedValues, grnDataSet, isStoreExecutive, isStoreManager, uc.approvedRejected]);

  const merchantUserDataSet = useMemo(() => mk(
    "Merchant Invoice",
    centreText((merchantInvoiceApprovedRejectedValues || []).reduce((s, v) => s + v, 0), "Total"),
    ["Approved", "Rejected"],
    uc.approvedRejected,
    [
      { value: "Approved", color: uc.approvedRejected[0] },
      { value: "Rejected", color: uc.approvedRejected[1] },
    ],
    [
      { label: "Approved", value: merchantInvoiceApprovedRejectedValues[0] || 0, color: uc.approvedRejected[0] },
      { label: "Rejected", value: merchantInvoiceApprovedRejectedValues[1] || 0, color: uc.approvedRejected[1] },
    ]
  ), [merchantInvoiceApprovedRejectedValues, uc.approvedRejected]);

  const vendorResponseTimeDataSet = useMemo(() => ({
    chartData: [
      { label: "Average Response Time", backgroundColor: bc.responseTime[0], barPercentage: 0.98, data: analyticsData?.vendorResponseTime?.values?.maxTime[0] },
      { label: "Minimum Response Time", backgroundColor: bc.responseTime[1], barPercentage: 0.98, data: analyticsData?.vendorResponseTime?.values?.minTime[0] },
    ],
    chartYAxisLabels: analyticsData?.vendorResponseTime?.labels,
    cardHeading: "Supplier Response Time",
    chartIndicators: [{ value: "Average Response Time (ART)", color: bc.responseTime[0] }, { value: "Minimum Response Time (MRT)", color: bc.responseTime[1] }],
  }), [analyticsData?.vendorResponseTime?.labels, analyticsData?.vendorResponseTime?.values?.maxTime, analyticsData?.vendorResponseTime?.values?.minTime, bc.responseTime]);

  const approverResponseTimeDataSet = useMemo(() => ({
    chartData: [
      { label: "Response Time In Hours", backgroundColor: bc.responseTime[0], barPercentage: 0.98, data: analyticsData?.approverResponseTime?.values?.maxTime[0] },
      { label: "Response Time In Minutes", backgroundColor: bc.responseTime[1], barPercentage: 0.98, data: analyticsData?.approverResponseTime?.values?.minTime[0] },
    ],
    chartYAxisLabels: (analyticsData?.approverResponseTime?.labels || []).map(l => `PO #${l}`),
    cardHeading: "Approver Response Time",
    chartIndicators: [{ value: "Response Time in Hours (RTH)", color: bc.responseTime[0] }, { value: "Response Time in Minutes (RTM)", color: bc.responseTime[1] }],
  }), [analyticsData?.approverResponseTime?.labels, analyticsData?.approverResponseTime?.values?.maxTime, analyticsData?.approverResponseTime?.values?.minTime, bc.responseTime]);

  const prLineDataSet = useMemo(() => ({
    cardHeading: "Total PR Created",
    chartLabels: ["PR Created"],
    chartIndicators: [{ value: "PR Created", color: bc.rfqCreated?.[0] || "#2ecc71" }],
    barColor: [bc.rfqCreated?.[0] || "#2ecc71"],
  }), [bc.rfqCreated]);

  const rfqLineDataSet = useMemo(() => ({
    cardHeading: "Total RFQ Created",
    chartLabels: ["RFQ Created"],
    chartIndicators: [{ value: "RFQ Created", color: bc.rfqCreated[0] }],
    barColor: bc.rfqCreated,
  }), [bc.rfqCreated]);

  const poLineDataSet = useMemo(() => ({
    cardHeading: "Purchase Orders Released",
    chartLabels: ["Purchase Order"],
    chartIndicators: [{ value: "Purchase Orders", color: bc.totalPurchaseOrders[0] }],
    barColor: bc.totalPurchaseOrders,
  }), [bc.totalPurchaseOrders]);

  const vendorLineDataSet = useMemo(() => ({
    cardHeading: "Supplier Onboarding: Initiated vs Onboarded",
    chartIndicators: [{ value: "Initiated", color: bc.vendorOnboarding[0] }, { value: "Onboarded", color: bc.vendorOnboarding[1] }],
    barColor: bc.vendorOnboarding[0],
  }), [bc.vendorOnboarding]);

  const vendorOnboardingExtraDataSets = useMemo(() => ([
    {
      label: "Onboarded",
      data: vendorOnboardingTrend.onboardedValues,
      borderColor: bc.vendorOnboarding[1],
      backgroundColor: bc.vendorOnboarding[1],
    },
  ]), [bc.vendorOnboarding, vendorOnboardingTrend.onboardedValues]);

  const topSelectedVendorsDataSet = useMemo(() => ({
    cardHeading: "",
    chartIndicators: [{ value: "Selected RFQs", color: bc.vendorSelected[0] }],
    barColors: bc.vendorSelected,
  }), [bc.vendorSelected]);

  const totalSpendByItemsDataSet = useMemo(() => ({
    cardHeading: "",
    chartIndicators: [{ value: "Total Spend", color: bc.totalSpend[0] }],
    barColors: bc.totalSpend,
  }), [bc.totalSpend]);

  const reportCardData = [
    { cardName: "Purchase Orders Released", cardImg: totalPOIMg, cardValue: `Rs.${analyticsData?.totalPOValue ?? 0}` },
    { cardName: "First time Purchase Cost Savings V1", cardImg: firstTimeCostSavingsImg, cardValue: `Rs.${(analyticsData?.costSavingsMetric1 ?? 0).toLocaleString()}` },
    { cardName: "First time Purchase Cost Savings V2", cardImg: graphImg, cardValue: `Rs.${(analyticsData?.costSavingsMetric2 ?? 0).toLocaleString()}` },
    { cardName: "Repeat Purchase Cost Savings", cardImg: trophyImg, cardValue: `Rs.${(analyticsData?.repeatPurchaseCostSavings ?? 0).toLocaleString()}` },
    { cardName: "Registered Suppliers", cardImg: vendorImg, cardValue: `${Number(vendorTotalCount) || 0}` },
    ...(data.access_type === "User" ? [{ cardName: "Raised PR", cardImg: prImg, cardValue: `${raisedPRTotal}` }] : []),
    { cardName: "Invoice Generated", cardImg: invoiceImg, cardValue: `${orgInvoiceTotal}` },
  ];

  const showBuyerDashboardSkeleton = isBuyerDashboard && (!hasLoadedDashboard || loadingState);

  if (showBuyerDashboardSkeleton) {
    return <BuyerDashboardSkeleton />;
  }

  if (isBuyerDashboard) {
    return (
      <NewBuyerDashboard
        dashboardResponse={dashboardResponse}
        loadingState={loadingState}
        navigate={navigate}
        bc={bc}
        spendItems={spendItems}
        spendTableHeadings={headings}
        spendPaginationData={paginationData}
        spendPageNumber={pageNumber}
        setSpendPageNumber={setPageNumber}
        spendSearchQuery={searchQuery}
        setSpendSearchQuery={setSearchQuery}
        spendTableLoading={spendItemsLoading}
        spendSortingColumnName={sortingColumnName}
        spendSortingOrder={sortingOrder}
        setSpendSortingColumnName={setSortingColumnName}
        setSpendSortingOrder={setSortingOrder}
      />
    );
  }

  if (isUserDashboard) {
    return (
      <UserDashboard
        dashboardResponse={dashboardResponse}
        loadingState={loadingState}
      />
    );
  }

  /* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
     RENDER
  â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */
  return (
    <div className={classes.dashboardPage}>

      {/* Page title */}
      <div className={classes.pageSectionPad}>
        <HeaderTitle titleText={data.access_type === "User" ? "Procurement Command Center" : "Buyer Workbench"} />
      </div>

      {/* Filters */}
      <div className={classes.pageSectionPadTop}>
        <div className={`${classes.filters} ${classes.flex}`}>
          {data.access_type === "Buyer" && (
            <>
              <DSelectInput options={vendorList.values} getIDValue={true} customClass={classes.filterFields} label="Supplier Company Name" setIDValue={(e) => { setVendorDetails(p => ({ ...p, vendorID: e })); getvendorName(e); }} onChange={(e) => setVendorDetails(p => ({ ...p, vendorName: e }))} />
              <DSelectInput id="vendorName" options={vendornameList.values} getIDValue={true} customClass={classes.filterFields} label="Supplier Name" disabled={!vendorDetails?.vendorID?.length} setIDValue={(e) => setVendorNameDetails(p => ({ ...p, buyerID: e }))} onChange={(e) => setVendorNameDetails(p => ({ ...p, buyerName: e }))} />
              <DSelectInput options={itemList.values} customClass={classes.filterFields} getIDValue={true} label="Item Name" setIDValue={(e) => setItemCode(p => ({ ...p, item_token: e }))} onChange={(e) => setItemCode(p => ({ ...p, item_code: e }))} />
            </>
          )}
          <DSelectInput options={durationList} customClass={classes.filterFields} label="Duration" onChange={(e) => { setDuration(e); setFromDate({ value: "", isValid: true }); setToDate({ value: "", isValid: true }); }} />
          <DDateInput customClass={classes.filterFields} type="date" label="Start Date" disableFuture={true} onChange={(e) => setFromDate({ isValid: emptyCheck(e), value: e })} disabledInput={duration} value={fromDate} error={!fromDate?.isValid} errorMsg="From date is required" />
          <div className={`${classes.flex} ${classes.filterSearch}`}>
            <DDateInput customClass={classes.filterFields} type="date" label="End Date" disableFuture={true} onChange={(e) => setToDate({ isValid: emptyCheck(e), value: e })} disabledInput={duration} value={toDate} error={!toDate?.isValid} errorMsg="To date is required" />
            <DButton buyerBtn={true} labelImg={btnImg} customWrapperClass={classes.filterBtn} customClass={classes.button} iconWidth="2rem" iconHeight="2rem" onClick={handleFilterSearch} />
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className={classes.pageSectionPadMain}>
        <div className={classes.dashboardGroup}>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: "1.25rem",
            marginBottom: "1.75rem",
            alignItems: "stretch",
          }}
        >
          {reportCardData.map((e, i) => (
            <div
              key={i}
              style={{
                height: "100%",
                display: "flex",
              }}
            >
              <Reportcard
                index={i}
                title={e.cardName}
                value={e.cardValue}
                reportImg={e.cardImg}
                loadingState={loadingState}
              />
            </div>
          ))}
        </div>

        {/* â•â•â•â• BUYER â€” 2-COLUMN GRID â•â•â•â• */}
        {data.access_type === "Buyer" && (
          <>
            {/* â”€â”€ Row 1: PR Summary (left) | RFQ Summary (right) â”€â”€ */}
            <div className={`${classes.twoColResponsive} ${classes.rowGap}`}>

              {/* LEFT: PR Summary */}
              <SectionCard
                title="PR Summary"
                dropdowns={
                  <Dropdowns year={prChartYear} month={prChartMonth} yearOptions={prYearOptions} monthOptions={prMonthOptions}
                    onYearChange={setPRChartYear} onMonthChange={setPRChartMonth} />
                }
              >
                {hasPRAccess && (
                  <>
                    <div style={{ ...blockWrap, cursor: "pointer" }} onClick={() => navigate("/Buyer_dashboard/PR")}>
                      <LineChart inline dataLabel={prMonthlyData.labels} dataValues={prMonthlyData.values} durationValue="weekly" chartHeight={180}
                        chartDataSet={prLineDataSet}
                        loadingState={loadingState} disableDuration={true} />
                    </div>
                    <Divider />
                    <div style={blockWrap}>
                      <div onClick={() => navigate("/Buyer_dashboard/PR")} style={{ cursor: "pointer" }}>
                        <DonutChart inline chartValues={overallPRValues} chartDataSet={buyerPRDataSet} loadingState={loadingState} />
                      </div>
                    </div>
                  </>
                )}
              </SectionCard>

              {/* RIGHT: RFQ Summary */}
              <SectionCard
                title="RFQ Summary"
                dropdowns={
                  <Dropdowns year={rfqChartYear} month={rfqChartMonth} yearOptions={rfqYearOptions} monthOptions={prMonthOptions}
                    onYearChange={setRfqChartYear} onMonthChange={(v) => { setRfqChartMonth(v); setRFQCreationOption(v === "all" ? "monthly" : "weekly"); }} />
                }
              >
                <div style={{ ...blockWrap, cursor: "pointer" }} onClick={() => navigate("/Buyer_dashboard/RFQ")}>
                  <LineChart inline dataLabel={rfqFiltered.labels} dataValues={rfqFiltered.values} chartHeight={180}
                    chartDataSet={rfqLineDataSet}
                    loadingState={loadingState} durationValue={rfqChartDuration} disableDuration={true} />
                </div>
                <Divider />
                <div style={twoColGrid}>
                  <div style={blockWrap}>
                    <div onClick={() => navigate("/Buyer_dashboard/RFQ")} style={{ cursor: "pointer" }}>
                      <DonutChart inline chartValues={submittedAndSelectedDataValue} chartDataSet={submittedDataSet} loadingState={loadingState} />
                    </div>
                  </div>
                  <div style={blockWrap}>
                    <div onClick={() => navigate("/Buyer_dashboard/RFQ")} style={{ cursor: "pointer" }}>
                      <DonutChart inline chartValues={pendingAndClosedRFQDataValues} chartDataSet={pendingClosedDataSet} loadingState={loadingState} />
                    </div>
                  </div>
                </div>
              </SectionCard>
            </div>

            {/* â”€â”€ Row 2: PO Summary (left) | Vendor Summary (right) â”€â”€ */}
            <div className={`${classes.twoColResponsive} ${classes.rowGap}`}>

              {/* LEFT: PO Summary */}
              <SectionCard
                title="PO Summary"
                dropdowns={
                  <Dropdowns year={poChartYear} month={poChartMonth} yearOptions={poYearOptions} monthOptions={prMonthOptions}
                    onYearChange={setPoChartYear} onMonthChange={(v) => { setPoChartMonth(v); setTotalPOOption(v === "all" ? "monthly" : "weekly"); }} />
                }
              >
                <div style={{ ...blockWrap, cursor: "pointer" }} onClick={() => navigate("/Buyer_dashboard/PO")}>
                  <LineChart inline dataLabel={poFiltered.labels} dataValues={poFiltered.values} chartHeight={180}
                    chartDataSet={poLineDataSet}
                    vendorChart={true} loadingState={loadingState} durationValue={poChartDuration} disableDuration={true} />
                </div>
                <Divider />
                <div style={blockWrap}>
                  <div onClick={() => navigate("/Buyer_dashboard/PO")} style={{ cursor: "pointer" }}>
                    <DonutChart inline chartValues={openCancelPendingDataValue} chartDataSet={poApprovalDataSet} loadingState={loadingState} />
                  </div>
                </div>
              </SectionCard>

              {/* RIGHT: Vendor Summary */}
              <SectionCard title="Supplier Summary">
                <div style={{ ...blockWrap, cursor: "pointer" }} onClick={() => navigate("/Buyer_dashboard/Invite")}>
                  <LineChart inline dataLabel={vendorOnboardingTrend.labels} dataValues={vendorOnboardingTrend.initiatedValues} chartHeight={180}
                    extraDataSets={vendorOnboardingExtraDataSets}
                    chartDataSet={vendorLineDataSet}
                    loadingState={loadingState} durationValue="monthly" disableDuration={true} xTickLimit={5} vendorChart={true} />
                </div>
                <Divider />
                <div style={twoColGrid}>
                  <div style={blockWrap}>
                    <div onClick={() => navigate("/Buyer_dashboard/Vendors")} style={{ cursor: "pointer" }}>
                      <DonutChart inline chartValues={vendorSummaryValues} chartDataSet={vendorSummaryDataSet} loadingState={loadingState} />
                    </div>
                  </div>
                  <div style={blockWrap}>
                    <InlineHeading title="Vendors Selected for Next RFQs" />
                    <div onClick={() => navigate("/Buyer_dashboard/Vendors")} style={{ cursor: "pointer" }}>
                      <BarChart inline mainData={topSelectedVendorsValues} labels={topSelectedVendorsLabels}
                        chartDataSet={topSelectedVendorsDataSet}
                        loadingState={loadingState} />
                    </div>
                  </div>
                </div>
              </SectionCard>
            </div>

            {/* â”€â”€ Operations & Reconciliation â€” full width â”€â”€ */}
            <SectionCard title="Operations & Reconciliation">
              <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                gap: "1.5rem",
                alignItems: "stretch",
              }}>
                <div>
                  <div onClick={() => navigate("/GRN_Dashboard/GRN")} style={{ cursor: "pointer" }}>
                    <DonutChart inline chartValues={grnSummaryValues} chartDataSet={grnDataSet} loadingState={loadingState} />
                  </div>
                </div>
                <div>
                  <div onClick={() => navigate("/Buyer_dashboard/Matching")} style={{ cursor: "pointer" }}>
                    <DonutChart inline chartValues={twmSummaryValues} chartDataSet={twmDataSet} loadingState={loadingState} />
                  </div>
                </div>
                <div>
                  <div onClick={() => navigate("/Buyer_dashboard/Invoice")} style={{ cursor: "pointer" }}>
                    <DonutChart inline chartValues={merchantInvoiceValues} chartDataSet={merchantDataSet} loadingState={loadingState} />
                  </div>
                </div>
              </div>
            </SectionCard>
          </>
        )}

        {/* â•â•â•â• USER â€” single card vertical â•â•â•â• */}
        {data.access_type === "User" && (
          <SectionCard
            title="PR Summary"
            dropdowns={
              <Dropdowns year={prChartYear} month={prChartMonth} yearOptions={prYearOptions} monthOptions={prMonthOptions}
                onYearChange={setPRChartYear} onMonthChange={setPRChartMonth} />
            }
          >
            {hasPRAccess && (
              <div onClick={() => navigate("/User_dashboard/PR")} style={{ cursor: "pointer" }}>
                <LineChart inline dataLabel={prMonthlyData.labels} dataValues={prMonthlyData.values} durationValue="weekly"
                  chartDataSet={prLineDataSet}
                  loadingState={loadingState} disableDuration={true} />
              </div>
            )}
            <Divider />
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "1.5rem" }}>
              {hasPRAccess && <div onClick={() => navigate("/User_dashboard/PR", { state: { status: "all" } })} style={{ cursor: "pointer" }}><DonutChart inline chartValues={overallPRValues} chartDataSet={orgPRDataSet} loadingState={loadingState} /></div>}
              {hasPOAccess && <div onClick={() => navigate("/User_dashboard/PO")} style={{ cursor: "pointer" }}><DonutChart inline chartValues={purchaseOrderData} chartDataSet={poUserDataSet} loadingState={loadingState} /></div>}
              <div onClick={() => navigate("/User_dashboard/Matching")} style={{ cursor: "pointer" }}><DonutChart inline chartValues={isFinanceUser ? twmApprovedRejectedValues : twmSummaryValues} chartDataSet={twmUserDataSet} loadingState={loadingState} /></div>
              {hasGRNAccess && isStoreAssistant && <div onClick={() => navigate("/GRN_Dashboard/GRN")} style={{ cursor: "pointer" }}><DonutChart inline chartValues={grnSummaryValues} chartDataSet={grnDataSet} loadingState={loadingState} /></div>}
              {hasGRNAccess && (isStoreExecutive || isStoreManager) && <div onClick={() => navigate("/GRN_Dashboard/GRN")} style={{ cursor: "pointer" }}><DonutChart inline chartValues={grnApprovedRejectedValues} chartDataSet={grnUserDataSet} loadingState={loadingState} /></div>}
              {hasMerchantInvoiceAccess && <div onClick={() => navigate("/User_dashboard/Invoice")} style={{ cursor: "pointer" }}><DonutChart inline chartValues={merchantInvoiceApprovedRejectedValues} chartDataSet={merchantUserDataSet} loadingState={loadingState} /></div>}
            </div>
          </SectionCard>
        )}

        {/* â”€â”€ Total Spend By Items Table â”€â”€ */}
        <SectionCard title="Total Spend by Items">
          <div style={{ marginBottom: "0.75rem" }}>
            <SearchBar onChange={(q) => { setSearchQuery(q); setPageNumber(1); }} />
          </div>
          <DataTable headings={headings} tableData={spendItems} actions={false} tableSize={spendItems?.length === 0 ? "100%" : "100vw"} viewBtn={false} deleteBtn={false} editBtn={false} sorting={true} errorMessage={tableProps.errorMessage} isLoading={tableProps.isLoading} itemsTable={true} setSortingColumnName={setSortingColumnName} sortingColumnName={sortingColumnName} setSortingOrder={setSortingOrder} sortingOrder={sortingOrder} />
          <PaginationComponent pageNumber={pageNumber} currentPage={currentPage || 0} itemsPerPage={itemsPerPage || 0} totalItems={totalItems || 0} setPageNumber={setPageNumber} previouPageClick={() => previouPageClick(pageNumber, setPageNumber)} nextPageClick={() => nextPageClick(pageNumber, setPageNumber, paginationData)} disablePrevious={parseInt(pageNumber) === 1 || pageNumber === ""} disableNext={parseInt(pageNumber) === paginationData?.page_count || !paginationData || pageNumber === ""} />
        </SectionCard>

        {/* â”€â”€ Total Spend Bar Chart â”€â”€ */}
        <SectionCard title="Total Spend by Items">
          <BarChart inline mainData={analyticsData?.totalSpentByItems?.values} labels={analyticsData?.totalSpentByItems?.labels}
            chartDataSet={totalSpendByItemsDataSet}
            loadingState={loadingState} onCardClick={() => navigate("/Buyer_dashboard/Items")} />
        </SectionCard>

        {/* â”€â”€ Response Time â”€â”€ */}
        {data.access_type === "Buyer" && (
          <SectionCard title="Supplier Response Time">
            <HorizontalBarChart inline chartData={vendorResponseTimeDataSet.chartData} chartDataSet={vendorResponseTimeDataSet} loadingState={loadingState} onCardClick={() => navigate("/Buyer_dashboard/Vendors")} />
          </SectionCard>
        )}
        {data.access_type === "User" && (
          <SectionCard title="Approver Response Time">
            <HorizontalBarChart inline chartData={approverResponseTimeDataSet.chartData} chartDataSet={approverResponseTimeDataSet} loadingState={loadingState} approveData={true} onCardClick={() => navigate("/User_dashboard/PO")} />
          </SectionCard>
        )}
        </div>
      </div>

    </div >
  );
};

export default BuyerDashboardTab;
